import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    root: _defineProperty({
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }, mp, {
      display: 'block'
    })
  };
};
export default generateStyle;